import { SvgIconProps } from "@material-ui/core";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import React from "react";

export const OpenCVIcon = (props: SvgIconProps) => <FolderOpenIcon {...props} />;
